import logo from "./logo.svg";
import "./App.css";
import Hero from "./components/hero";
import Footer from "./components/footer";
import Login from "./components/login";
import ButtonList from "./components/buttonList";
import DataEntry from "./components/dataEntry";
import DataTable from "./components/dataTable";
import FilterPage from "./components/filterPage";
import { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PreviewPage from "./components/previewPage";
import FrkDataEntry from "./components/frkSaleEntry";
import BillOfSupply from "./components/billOfSupply";
import BillOfSupplyEntry from "./components/billOfSupplyEntry";

// const baseURL = "https://bhagwatitradingwebsiteexpress-cr5j5yn2ca-uc.a.run.app/api/v1";
var baseURL = "https://bhagwatitradingbeta-cr5j5yn2ca-uc.a.run.app/api/v1"; //BETA URL
if (window.location.hostname == "bt.ebinge.in" || window.location.hostname == "bhagwatitrading.netlify.app") {
  baseURL =
    "https://bhagwatitradingwebsiteexpress-cr5j5yn2ca-uc.a.run.app/api/v1"; //PRODUCTION URL
} else if (window.location.hostname == "localhost") {
  baseURL = "http://localhost:3001/api/v1"; //LOCALHOST URL
}
console.log(baseURL);

function App() {
  localStorage.setItem("baseURL", baseURL);

  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("authToken") != null ? true : false
  );
  const [visiblePage, setVisiblePage] = useState("buttonList");
  return (
    <Router>
      <Routes>
        <Route
          exact
          path="/"
          element={
            <div class="container">
              <Hero />
              {!isLoggedIn && <Login setIsLoggedIn={setIsLoggedIn} />}
              {isLoggedIn && visiblePage == "buttonList" && (
                <ButtonList
                  setVisiblePage={setVisiblePage}
                  setIsLoggedIn={setIsLoggedIn}
                />
              )}

              {isLoggedIn && visiblePage == "dataEntry" && (
                <DataEntry setIsLoggedIn={setIsLoggedIn} />
              )}

              {isLoggedIn && visiblePage == "dataTable" && (
                <DataTable setIsLoggedIn={setIsLoggedIn} />
              )}

              {isLoggedIn && visiblePage == "filterPage" && (
                <FilterPage setIsLoggedIn={setIsLoggedIn} />
              )}

              {isLoggedIn && visiblePage == "frkDataEntry" && (
                <FrkDataEntry setIsLoggedIn={setIsLoggedIn} />
              )}

              {isLoggedIn && visiblePage == "billOfSupplyEntry" && (
                <BillOfSupplyEntry setIsLoggedIn={setIsLoggedIn} />
              )}

              <Footer />
            </div>
          }
        />
        <Route exact path="/preview" element={<PreviewPage />} />
        <Route exact path="/bos" element={<BillOfSupply />} />
      </Routes>
    </Router>
  );
}

export default App;
